import { FC, SVGProps } from 'react';
import { LinkProps } from 'react-router-dom';
import classNames from 'classnames';

import ButtonLink from '~/components/atoms/ButtonLink';
import { IButtonCleanProps } from '~/components/ButtonClean';

import styles from './Icon.module.scss';

export type TIcon = (IButtonCleanProps | LinkProps) & {
  color?: string;
  className?: string;
  background?: boolean;
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const IconHoc = (Svg: FC<SVGProps<SVGSVGElement> & { title?: string }>) => {
  const Icon = ({ color, background = true, ...props }: TIcon) => (
    // @ts-ignore dunno why it don't work here
    <ButtonLink
      {...props}
      className={classNames(props.className, background && styles.background)}
    >
      <Svg style={color ? { stroke: color } : undefined} />
    </ButtonLink>
  );
  Icon.displayName = 'Icon';

  return Icon;
};

export default IconHoc;
